import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AddOverdraftRequest,
  BooleanResponse,
  BooleanResponseV2,
  UpdateFinancialRequest,
} from 'src/app/models/financial-information/financial-information.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FinancialInformationService {
  private readonly base = environment.url;

  constructor(private http: HttpClient) {}

  updateFinancial(
    payload: UpdateFinancialRequest
  ): Observable<BooleanResponse> {
    return this.http.post<BooleanResponse>(
      `${this.base}/services/update-financial`,
      payload
    );
  }

  addOverdraft(payload: AddOverdraftRequest): Observable<BooleanResponseV2> {
    return this.http.post<BooleanResponseV2>(
      `${this.base}/services/add-overdraft`,
      payload
    );
  }
}
